import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'
import { ManageAccountsPage, ManageAccountPage } from '.'

const AgencyManageAccountsRouter = (): React.ReactElement => {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <ManageAccountsPage />
      </Route>
      <Route path={`${path}/:clientNumber`}>
        <ManageAccountPage />
      </Route>
    </Switch>
  )
}

export default AgencyManageAccountsRouter
